/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Content1Inputs */

const vi_cmspost_content1 = /** @type {(inputs: Cmspost_Content1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nội dung`)
};

/**

* @param {Cmspost_Content1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_content1 = /** @type {((inputs?: Cmspost_Content1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Content1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_content1(inputs)
});
export { cmspost_content1 as "cmsPost_content" }